/**
 * handleSubmit.js
 *
 * Copyright (c) apploft. GmbH
 */

import {http, URL, APIDefinition} from 'apploft-cloud-client';
import {createRequestData} from 'apploft-cloud-forms';
import {submittingForm} from '../ContentStateSymbol';
import {
  formResponseReceived,
  failedFormSubmission,
} from '../ContentEventSymbol';

/**
 * Submits `formData` for `section` of `api` issuing and handling
 * an HTTP POST request – it returns the new state.
 *
 * @param {*} selection Selected section and API.
 * @param {*} payload The event payload.
 */
export default function handleSubmit({section, api}, {formData, dispatch}) {
  const paths = APIDefinition.pathsMatching(section, api);
  const url = URL.createPostUrl({api, paths});
  const authorization = APIDefinition.keyAdminAuth(api);
  const controller = new AbortController();

  const {signal} = controller;
  const {post} = http;

  const data = createRequestData(formData);

  // Assuming we are reloading the list in the success case, we can ignore
  // the response here.

  post({url, data, authorization, signal})
    .then(res => {
      dispatch({
        event: formResponseReceived,
        payload: {section, api, dispatch},
      });
    })
    .catch(error => {
      if (error instanceof DOMException) {
        console.assert(
          error.message === 'The user aborted a request.',
          `unexpected error: ${error.message}`,
        );

        return;
      }

      dispatch({event: failedFormSubmission, payload: error});
    });

  return {
    state: submittingForm,
    data: {section, api, formData},
    controller,
  };
}
